/**
 * @module components/Footer
 * @description Site footer component with links to terms and user guide.
 * Displays consistently across all pages in the main layout.
 */
import React from 'react';

import { Link } from '@/components/Link';

import UserGuide from './UserGuide';

/**
 * @typedef FooterProps
 * @property {string} [className] - Optional CSS class name
 */

/**
 * @component Footer
 * @type {React.FC<FooterProps>}
 * @summary Site footer with navigation links to Terms and User Guide
 * @param {FooterProps} props - Component props
 * @returns {React.ReactElement} Footer container with links
 */
export const Footer = (props) => (
  <div className={`container--l mxa ac py1 ${props.className || ''}`}>
    <Link to="/terms" className="pb1 px05">
      Terms and Conditions
    </Link>
    <UserGuide className="pb1 px05 ml025" />
  </div>
);
